
  import Level from '@/ui/components/common/Level.vue';
  import { Loading } from '@/ui/components/Loading';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { computed, defineComponent } from 'vue';
  import Sidebar from '@/ui/components/integrations/home/Sidebar.vue';
  import ListingContents from '@/ui/components/integrations/home/ListingContents.vue';
  import { useIntegrationsHomeStore } from '@/stores/integrationsHome';

  export default defineComponent({
    components: {
      PageTitle,
      Level,
      Sidebar,
      ListingContents,
      Loading,
    },
    setup() {
      const store = useIntegrationsHomeStore();
      store.loadIntegrations();
      const loading = computed(() => store.loading);

      return {
        loading,
      };
    },
  });
